import { ParseMapOptions } from "@/components/parser/types";
import { domToReact, Element } from "html-react-parser";
import { parseByNodeString, parseMap } from "@/components/parser/Mapper";
import styles from "@/styles/post.module.css";
import { createElement } from "react";

export const Table = (domNode: Element, options: ParseMapOptions): JSX.Element | undefined => {
  return createElement(
    domNode.name,
    { className: styles[domNode.name] },
    domToReact(domNode.children, {
      replace: (domNode) => {
        if (!domNode.hasOwnProperty("attribs")) {
          return;
        }
        const domNodeElement = domNode as Element;

        return parseByNodeString(parseMap, domNodeElement.name, domNodeElement, options);
      },
    })
  );
};
